import React, { useCallback, useContext, useEffect } from 'react';
import { SET_TEST_DURATION, TEST_CONFIGURATION } from '../../utils/Constants';
import InputboxLabel from '../../components/InputboxLabel';
import { ABContext } from '../../contexts/ABContext';
import { TPayload } from '../../types/ab';

const TestConfiguration = () => {

    const abContext = useContext(ABContext);

    useEffect(() => {
        if (abContext?.setPayload) {
            abContext.setPayload((prevPayload: TPayload) => ({
                ...prevPayload,
                test_duration: prevPayload?.test_duration ?? 0
            }));
        }
    }, [abContext?.setPayload]);

    const handleTestDurationChange = useCallback((newTestDuration: number) => {
        if (abContext?.payload) {
            abContext.setPayload((prevPayload: TPayload) => ({
                ...prevPayload,
                test_duration: newTestDuration
            }));
        }
    }, []);

    return (
        <div>
            <label className='tw-font-semibold tw-text-black tw-text-sm tw-mb-3'>{TEST_CONFIGURATION}</label>
            <div className='tw-flex tw-items-start tw-gap-10'>
                <div className='tw-w-[15%] tw-text-black'>
                    <InputboxLabel label={SET_TEST_DURATION} showAdditionalLabel={true} onChange={handleTestDurationChange} initialValue={abContext?.payload?.test_duration != null ? Math.ceil(abContext?.payload?.test_duration) : 1} />
                </div>
            </div>
        </div>
    );
}

export default TestConfiguration;